import React, { useState } from "react";

// ============================================================
// CONFIRM MODAL — component reutilizabil pentru toate confirmările
// ============================================================
// Props:
//   open        — boolean: arată/ascunde modalul
//   title       — titlul modalului
//   text        — textul (poate fi string sau JSX)
//   confirmLabel— textul butonului de acțiune (ex: "Șterge", "Blochează")
//   loadingLabel— text afișat cât rulează (ex: "Se șterge...")
//   confirmStyle— stilul butonului de acțiune (btnRed/btnOrange/btnGreen/btnPrimary)
//   cancelLabel — text buton anulare (default "Anulează")
//   onConfirm   — funcție async apelată la click pe confirmare
//   onCancel    — funcție apelată la click pe anulare
//   variant     — "default" | "error" (error = border roșu + icon)
// ============================================================
function ConfirmModal({
  open,
  title,
  text,
  confirmLabel = "Confirmă",
  loadingLabel,
  confirmStyle,
  cancelLabel = "Anulează",
  onConfirm,
  onCancel,
  variant = "default",
  hideCancel = false,
}) {
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const handleConfirm = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await onConfirm();
    } finally {
      setLoading(false);
    }
  };

  const cardStyle = variant === "error"
    ? { background: "#0f0f1a", border: "1px solid rgba(239,68,68,0.3)" }
    : { background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)" };

  const btnGray = { background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.08)", color: "rgba(255,255,255,0.7)" };
  const defaultConfirmStyle = { background: "linear-gradient(135deg, #6366f1, #8b5cf6)", color: "white" };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50" style={{ background: "rgba(0,0,0,0.8)" }}>
      <div className="rounded-2xl p-6 max-w-md w-full mx-4" style={cardStyle}>
        <div className="flex items-center gap-3 mb-2">
          {variant === "error" && <span className="text-2xl">⚠️</span>}
          <h3 className="text-lg font-bold text-white">{title}</h3>
        </div>
        {text && (
          <div className="text-sm mb-4" style={{ color: "rgba(255,255,255,0.5)" }}>
            {text}
          </div>
        )}
        <div className="flex gap-3">
          <button
            onClick={handleConfirm}
            disabled={loading}
            className="flex-1 py-2 rounded-xl text-sm font-medium disabled:opacity-60 inline-flex items-center justify-center gap-2"
            style={{ ...(confirmStyle || defaultConfirmStyle), cursor: loading ? "not-allowed" : "pointer" }}
          >
            {loading && (
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" style={{ animation: "spin 0.8s linear infinite", flexShrink: 0 }}>
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeOpacity="0.25" />
                <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
              </svg>
            )}
            {loading ? (loadingLabel || confirmLabel) : confirmLabel}
          </button>
          {!hideCancel && (
            <button
              onClick={onCancel}
              disabled={loading}
              className="flex-1 py-2 rounded-xl text-sm font-medium disabled:opacity-40"
              style={btnGray}
            >
              {cancelLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
